import IOption from "../interfaces/IOption"

export default function handleMultiSelect(selectedValues: IOption[]) {
  let values: IOption[] = []
  Object.assign(values, selectedValues)
  
  // clearing all selected values if all were chosen
  if (values.some(({value}) => value === "all")) {
    values = []
  }

  return values
}
